import hasherImport from 'hasher/dist/js/hasher.js';

/** Unwrap CJS default interop so setHash/getHash work under ESM namespace imports. */
const hasher = ((hasherImport as {default?: typeof hasherImport}).default ??
    hasherImport);

export {hasher};
export default hasher;
